import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginData } from 'src/app/core/models/customer-details';
import { HttpService } from './http-service';

@Injectable({ providedIn: 'root' })
export class LoginService {

  loggedInValue = false;
  currentSession: boolean;
  private messageSource = new BehaviorSubject(this.loggedInValue);
  currentMessage = this.messageSource.asObservable();
  constructor(private http: HttpClient, private httpService: HttpService) { }

  // login(user: LoginData): Observable<any> {
  //   let httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json"
  //     })
  //   };

  //   let url = environment.apiUrl + environment.activationPortal.login;
  //   let reqBody = { mobileNumber: user.userName, userpassword: user.password };
  //   return this.http.post(url, JSON.stringify(reqBody), httpOptions).pipe(
  //     map((data: any) => {
  //       this.messageSource.next((this.currentSession = data.passwordMatch));
  //       return data;
  //     }),
  //     catchError(this.errorMgmt)
  //   );
  // }

  // Error handling

  login(user): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.login;
    const reqBody = { deliteId: user.deliteId, password: user.password };
    return this.httpService.post(url, reqBody).pipe(map((data: any) => {
      this.messageSource.next((this.currentSession = data.passwordMatch));
      return data;
    }), catchError(this.errorMgmt));
  }

  // postLoginCheck(): Observable<any> {
  //   const url = environment.apiUrl + environment.activationPortal.postLoginCheck;
  //   return this.httpService.postWithRefershToken(url, {}).pipe(map((data: any) => {
  //     return data;
  //   }), catchError(this.errorMgmt));
  // }

  forgotPassword(user, id): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.forgotPassword;
    // const reqBody = {otp: user.otp, deliteId: user.deliteId, password: user.password };
    if (id === 1) {
      return this.httpService.postWithRefershToken(url, user).pipe(map((data: any) => {
        this.messageSource.next((this.currentSession = data.passwordMatch));
        return data;
      }), catchError(this.errorMgmt));
    } else {
      return this.httpService.post(url, user).pipe(map((data: any) => {
        this.messageSource.next((this.currentSession = data.passwordMatch));
        return data;
      }), catchError(this.errorMgmt));
    }
  }

  sendOtp(data: { deliteId: string; }): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.sendOtp;
    const reqBody = { deliteId: data.deliteId };
    return this.httpService.post(url, reqBody).pipe(map((returnData: any) => {
      // this.messageSource.next((this.currentSession = data.passwordMatch));
      return returnData;
    }), catchError(this.errorMgmt));
  }

  sendOtpForLogin(data: { deliteId: string; }): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.sendOtpForLogin;
    const reqBody = { deliteId: data.deliteId };
    return this.httpService.post(url, reqBody).pipe(map((returnData: any) => {
      // this.messageSource.next((this.currentSession = data.passwordMatch));
      return returnData;
    }), catchError(this.errorMgmt));
  }
  customer(data): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getCustomerDetails;
    const reqBody = { customerId: data.customerId, vinNumber: data.vinNumber };
    return this.httpService.postWithRefershToken(url, reqBody).pipe(map((returnData: any) => {
      // this.messageSource.next((this.currentSession = data.passwordMatch));
      return returnData;
    }), catchError(this.errorMgmt));
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else if(error.error.status["code"] == 80100) {
      // Get server-side error
      errorMessage = error.error.status["message"];
    } else {
      // Get server-side error
      errorMessage = error.error.status["message"];
    }
    return throwError(errorMessage);
  }

  verifyOtpForLogin(payload): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.verifyOtpForLogin;
    const reqBody = { otp: payload.otp , key: payload.loginOtpKey , deliteId: payload.deliteId};
    return this.httpService.post(url, reqBody).pipe(map((returnData: any) => {
      return returnData;
    }), catchError(this.errorMgmt));
  }
}
